export default __webpack_public_path__ + "static/media/Analysis-bro.046bf630.svg";